<template>
  <div>
    <app-contentpageheader>
      <b-img
        slot="entrySectionImage"
        fluid
        alt="Responsive image"
        :src="backgroundImg"
      />
      <h3 slot="entrySectionText">Baza wiedzy</h3>
    </app-contentpageheader>
    <app-knowledge />
    <app-footer />
  </div>
</template>
<script>
import ContentPageHeader from "../components/common/ContentPageHeader.vue";
import Knowledge from "../components/knowledge/Knowledge.vue";
import Footer from "../components/common/Footer.vue";
export default {
  data() {
    return {
      backgroundImg: require("../assets/common/wood.jpg")
    };
  },
  components: {
    "app-footer": Footer,
    "app-knowledge": Knowledge,
    "app-contentpageheader": ContentPageHeader
  }
};
</script>
<style scoped></style>
